import React from "react";

import { getBmsCopayLsFormInitialValues } from "./form/initialValues";
import { SaveButton } from "../../header";
import useBaseEEConfiguration from "../../hooks/useBaseEEConfiguration";
import { applyTrimFields } from "../../utils/updateFormData";
import renderReactFromJson from "../../utils/renderReactFromJson";
import formJson from "./form/BmsCopayLsFormJson.json";
import { CompleteFormButton } from "../../CompleteFormButton";
import { HEADER_SUBMIT_BUTTON_TYPES } from "../../constants";
import { dateFormatter } from "../../../../../utils/date";
import { EEsignatureStatuses } from "../../../../../constant/EEsignatureStatuses";

export const useBmsCopayLsConfiguration = () => {
  const vendorName = "bms";
  const eePlanType = "copay-ls";
  // Sidebar labels come from formJson.formSections[].sectionSidebar (no admin option), so no
  // translation keys are required under this rootPath. Kept for parity with other EE configs.
  const rootPath = "application_form_editor.bms.copay_ls";

  const baseConfig = useBaseEEConfiguration({ vendorName, eePlanType, rootPath, formJson });

  const bmsSpecificConfig = {
    activeFormSection: "",
    getFormInitialValues: ({ applicationForm }) => getBmsCopayLsFormInitialValues({ applicationForm, formJson }),
    getFormFromJson: (form) => renderReactFromJson(form, formJson),
    saveButton: (props) => (
      <SaveButton onSave={(form) => applyTrimFields(form)} id={"EE_bms_copay_ls_save_form"} {...props} />
    ),
    afterSubmissionPayload: () => ({}),
    applicationFormHeaderSubmission: (props) => <CompleteFormButton id={"EE_complete_button"} {...props} />,
    headerSubmitButtonType: HEADER_SUBMIT_BUTTON_TYPES.SUBMIT_FORM,
    getEnrollResultData: ({ application }) => ({
      bin: application?.bin,
      pcn: application?.pcn,
      group: application?.group,
      member_id: application?.memberId,
      approved_date: dateFormatter(application?.approvedDate) || "--"
    }),
    getAdditionalResultCardInformation: false,
    getApprovedResultDescription: () => <></>,
    getShowEnrollResult: (applicationForm) => applicationForm?.status === EEsignatureStatuses.SUBMITTED
  };

  return {
    ...baseConfig,
    ...bmsSpecificConfig
  };
};

export default useBmsCopayLsConfiguration;
